/**
 * SitePick front — SP 追従バー（商品詳細・`<=768px`。custom-chat spec §9.1 / SHARED-16=A）と
 * 「相談する」クリックの計測（GA4 `ask_open`。spec §14）。
 *
 * 追従バー: FV の CTA 囲み（`.p-site-cta` の FV 側）と末尾の CTA 囲み（`.p-site-cta--foot`）のどちらかが
 * 1px でも画面に入っている間は隠し、どちらも画面外のときだけ `is-visible`（IntersectionObserver。
 * 未対応環境は常時表示）。表示中は `<body>` に `has-sp-sticky-cta` を付けて下余白を足す（本文の最下部を隠さない）。
 * 比較トレイの上に積む位置・z-index は CSS（`--sp-tray-h`・55）。見た目のクラスは足し引きしない（状態クラスのみ）。
 * 価格・在庫の判定はしない。
 *
 * 計測: `data-sp-ask-open` 付きリンクのクリックで `ask_open` を push（item_id / ask_entry / ask_mode。本文・メールなし）。
 * 相談チャットが無効で /contact/ に向くときも送る（ask_mode=contact）。
 */

import { askOpen } from "./analytics.js";

const SP_QUERY = "(max-width: 768px)";

/**
 * 追従バー。
 */
export function initStickyCta() {
  const bar = document.querySelector(".js-sp-sticky-cta");
  if (!bar) {
    return;
  }
  const targets = Array.from(document.querySelectorAll(".p-site-cta"));
  const visible = new Set();
  const mq = typeof window.matchMedia === "function" ? window.matchMedia(SP_QUERY) : null;

  const update = () => {
    const show = (!mq || mq.matches) && visible.size === 0;
    bar.classList.toggle("is-visible", show);
    document.body.classList.toggle("has-sp-sticky-cta", show);
  };

  if (typeof window.IntersectionObserver !== "function" || targets.length === 0) {
    // 未対応環境は常時表示（SP のみ。CSS が 769px 以上では出さない）。
    update();
    return;
  }
  const io = new window.IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          visible.add(e.target);
        } else {
          visible.delete(e.target);
        }
      });
      update();
    },
    { threshold: 0 }
  );
  targets.forEach((t) => io.observe(t));
  if (mq && typeof mq.addEventListener === "function") {
    mq.addEventListener("change", update);
  }
}

/**
 * 「相談する」のクリック計測（委譲。/live/ でも main.js → ここが読まれる）。
 */
export function initAskOpenTracking() {
  document.addEventListener(
    "click",
    (ev) => {
      const target = ev.target instanceof Element ? ev.target.closest("a[data-sp-ask-open]") : null;
      if (!target) {
        return;
      }
      askOpen(
        target.getAttribute("data-sp-item-id") || "",
        target.getAttribute("data-sp-ask-open") || "",
        target.getAttribute("data-sp-ask-mode") || "",
        target.getAttribute("data-sp-ask-type") || ""
      );
    },
    { capture: true }
  );
}
